<template>
  <v-menu v-model="menu">
    <template v-slot:activator="{ on }">
      <v-btn
        ref="button"
        :icon="!showDownArrow"
        :text="showDownArrow"
        :rounded="showDownArrow"
        v-on="on"
        :large="large"
        :small="small"
        :x-small="xsmall"
        :class="page.flair.state == 2 ? cardType.highlight : null"
      >
        <page-type-icon
          :pageType="page.type"
          :small="small"
          :xsmall="xsmall"
          :state="page.flair.state"
        ></page-type-icon>
        <v-icon v-if="showDownArrow">arrow_drop_down</v-icon>
      </v-btn>
    </template>
    <v-card v-if="menu" class="page-type-select">
      <v-row no-gutters class="pa-2">
        <v-btn-toggle v-model="stateFlair">
          <v-btn small :input-value="1">
            <oh-v-icon name="md-checkcircle" class="mr-1"></oh-v-icon>
            Completed
            <!-- <page-type-icon :pageType="page.type" :small="xsmall" :state="1"></page-type-icon> -->
          </v-btn>
          <v-btn small :input-value="2">
            <oh-v-icon name="md-stars" class="mr-1"></oh-v-icon>
            Important
            <!-- <page-type-icon :pageType="page.type" :small="xsmall" :state="2"></page-type-icon> -->
          </v-btn>
        </v-btn-toggle>
        <v-spacer></v-spacer>
        <v-btn
          text
          class="col"
          :class="{ 'v-btn--active': isCodeBlock }"
          :color="isCodeBlock ? 'primary' : ''"
          @click="$emit('toggleCodeBlock')"
        >
          <v-icon>code</v-icon>
        </v-btn>
        <v-btn
          v-if="enabledFlair"
          text
          class="col"
          :class="{ 'v-btn--active': enabledFlair.includes('cardify') }"
          :color="enabledFlair.includes('cardify') ? 'primary' : ''"
          @click="$emit('updateFlair', { flair: 'cardify', enableState: 'toggle' })"
        >
          <v-icon>style</v-icon>
        </v-btn>
      </v-row>
      <icon-picker-options @pickIcon="cardType = $event" class="pa-2"></icon-picker-options>
    </v-card>
    <!-- <v-list dense>
      <template v-for="type in cardTypes">
        <v-list-item
          v-if="type.type != 'divider'"
          @click="cardType = type.value"
          :key="type.value"
          ref="listItem"
        >
          <v-list-item-icon>
            <v-icon
              :color="type.color"
              :style="type.style ? type.style : ''"
              >{{ type.icon }}</v-icon
            >
          </v-list-item-icon>
          <v-list-item-title>{{ type.label }}</v-list-item-title>
        </v-list-item>
        <template v-else>
          <v-divider :key="type.label + 'divider'"></v-divider>
          <v-subheader :key="type.label">{{ type.label }}</v-subheader>
        </template>
      </template>
    </v-list> -->
  </v-menu>
</template>

<script>
import cardTypes from './cardTypes';
import PageTypeIcon from './index';
import { pagesModule } from '@/store/database/pagesModule';
import useMultiSelect from '@/views/Context/use/useMultiSelect';
import IconPickerOptions from './IconPickerOptions.vue';
import { updatePage } from '@/components/ContextDoc/use/useDocActions';

export default {
  props: [
    'page',
    'large',
    'small',
    'xsmall',
    'type',
    'highlight',
    'selectedNoteIds',
    'parentPageId',
    'dragSelected',
    'showDownArrow',
    'enabledFlair'
  ],
  components: { PageTypeIcon, IconPickerOptions },
  data() {
    return {
      cardTypes,
      menu: false
    };
  },
  computed: {
    stateFlair: {
      get() {
        return this.page.flair.state - 1;
      },
      set(v) {
        const val = v + 1;
        if (this.page.flair.state == val) {
          this.$emit('updateFlair', { flair: 'state', value: 0 });
        } else {
          this.$emit('updateFlair', { flair: 'state', value: val });
        }
      }
    },
    cardType: {
      get() {
        const type = this.page.type >= 0 ? this.page.type : 1;
        return cardTypes.find(c => c.value == type);
      },
      set(v) {
        if (this.dragSelected) {
          console.log('drag selected');
          const { getSelectedNoteIds } = useMultiSelect();
          const selectedNoteIds = getSelectedNoteIds();
          console.log(selectedNoteIds);
          //  if we passed in selectedNoteIds there was stuff selected
          const parentPage = pagesModule.doc(this.parentPageId).data;
          const selectedPageIds = selectedNoteIds.map(n => parentPage.pageNotes[n].pageId);
          selectedPageIds.forEach(pageId => {
            updatePage({ pageId, update: { type: v } });
          });
        } else {
          updatePage({ pageId: this.page.id, update: { type: v } });
        }
      }
    },
    isCodeBlock() {
      return this.page.title.includes('<pre class=\"ql-syntax\"');
    }
  },
  methods: {
    open() {
      this.menu = true;
      this.$nextTick(() => {
        console.log(this.$refs.button);
        this.$refs.button.$el.focus();
      });
    }
  }
};
</script>

<style>
kbd {
  background: #eeeeee !important;
  color: #505050 !important;
  font-size: 12px;
  padding: 0.2em 0.4rem;
}
</style>
